import { render } from "./EduRegisterView.vue?vue&type=template&id=7278cf46&scoped=true"
import script from "./EduRegisterView.vue?vue&type=script&lang=js"
export * from "./EduRegisterView.vue?vue&type=script&lang=js"

import "./EduRegisterView.vue?vue&type=style&index=0&id=7278cf46&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7278cf46"]])

export default __exports__